import type { CustomAttributes } from '@atlaskit/feature-gate-js-client/types';

const FORWARDED_QUERY_PARAMS = ['source', 'variant'] as const;

export function getSourceCustomAttributes(): CustomAttributes {
	// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
	if (typeof window === 'undefined' || !window.location?.search) {
		return {};
	}

	try {
		// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
		const params = new URLSearchParams(window.location.search);
		const attributes: CustomAttributes = {};

		for (const key of FORWARDED_QUERY_PARAMS) {
			const value = params.get(key);
			if (value) {
				attributes[key] = value;
			}
		}

		return attributes;
	} catch {
		return {};
	}
}
